/**
* 头部菜单
*/ 
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-button class="logo">
            <img class="showimg" :src="imgshow">
            <label class="logoName">门店资料智能查询工具</label>
          </el-button>
          <div :style="{ display: loginState ? 'flex' : 'none' }">
            <el-button style="height:40px; margin-left: 20px;margin-top: 20px;" @click="userLogin = true">登录</el-button>
            <el-button style="height:40px; margin-right: 20px;margin-top: 20px;" @click="registerUser = true"
              type="success">注册</el-button>
          </div>
          <div :style="{ display: loginState ? 'none' : 'flex' }"
            style="display: flex;justify-content: space-between;width:38%">
            <div style="display: flex;justify-content: center;justify-content: center;align-items: center;">
              <el-popover placement="bottom" width="300" trigger="hover">
                <label style="color: red;">分享此链接，通过该链接注册的用户您可永久获得该用户付款额的30%</label></br>
                <a :href="commissionUrl">{{ commissionUrl }}</a>
                <el-button type="text" style="color: red;" slot="reference">推荐赚佣金</el-button>
              </el-popover>
              <label style="font-size: 10px;margin-left: 20px;">佣金： </label>
              <label style="margin-left: 10px;color: red;"> {{ bounty }} </label>
              <label style="font-size: 10px;margin-left: 20px;">剩余次数： </label>
              <label style="margin-left: 10px;color: red;"> {{ balance }} </label>
              <el-button type="text" @click="dialogTableVisible = true" style="margin-left: 10px;"> 充值</el-button>
            </div>

            <el-menu class="el-menu-demo" mode="horizontal">
              <el-submenu index="2" class="submenu">
                <template slot="title">{{ user.userName }}</template>
                <!-- <template slot="title">超级管理员</template> -->
                <el-menu-item index="/goods/address"
                  @click.native.stop="handleSelectMenu('/goods/address')">首页</el-menu-item>
                <el-menu-item index="/goods/RechargeSize"
                  @click.native.stop="handleSelectMenu('/goods/RechargeSize')">充值记录</el-menu-item>
                <el-menu-item @click="upPass = true" index="2-3">修改密码</el-menu-item>
                <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
              </el-submenu>
            </el-menu>
          </div>

          <el-dialog title="充值次数" :visible.sync="dialogTableVisible" :width="czDialog">
            <div>
              <el-form :model="fromOption" class="user-search">
                <el-form-item>
                  <el-radio-group v-model="fromOption.option">
                    <div class="container">
                      <el-radio-button size="medium" label="1">1次——3元</el-radio-button>
                      <el-radio-button size="medium" label="2">10次——25元</el-radio-button>
                      <el-radio-button size="medium" label="3">30次——50元</el-radio-button>
                    </div>
                  </el-radio-group>

                </el-form-item>
                <div style="width: 100%;height: 40px;">
                  <el-button type="primary" @click="recharge" style="float: right;">充值</el-button>
                </div>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="微信扫码充值" :visible.sync="wxPlayDialog" :width="wxDialog">
            <div id="qrcode"></div>
          </el-dialog>
          <el-dialog title="修改密码" :visible.sync="upPass" width="500px">
            <el-form label-position="left" :model="formInline" ref="formInline" class="demo-ruleForm login-container">
              <el-form-item label="原密码">
                <el-input placeholder="请输入旧密码" v-model="formInline.oldPassword" show-password> </el-input>
              </el-form-item>
              <el-form-item label="新密码：">
                <el-input placeholder="请输入新密码" v-model="formInline.password" show-password></el-input>
              </el-form-item>
              <div style="width: 100%;height: 40px;">
                <el-button type="primary" style="width:100%;" @click="upPassword('formInline')">修改密码</el-button>
              </div>
            </el-form>
          </el-dialog>

          <el-dialog :visible.sync="registerUser" :width="loginDialog" class="dialog">
            <registerInterface :ifShow100="true"></registerInterface>
          </el-dialog>
        </div>
      </el-col>
    </el-row>

    <div>
      <el-dialog :visible.sync="userLogin" :width="loginDialog" class="dialog">
        <div>
          <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
            class="demo-ruleForm login-container">
            <h3 class="title">用户登录</h3>
            <el-form-item prop="username">
              <el-input v-model="ruleForm.username" type="number" auto-complete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
            </el-form-item>
            <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
            <el-button type="text" @click="registerUser = true" style="float: right;">新用户注册</el-button>
            <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')"
                :loading="logining">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { loginout } from '../api/userMG'
import { updatePassword } from '../api/userMG'
import { nativePay } from '../api/userMG'
import { getSizeByUserId } from '../api/userMG'
import { getBountyByUserId } from '../api/userMG'
import registerInterface from '../views/register.vue'
import { login } from '../api/userMG'
import { register } from '../api/userMG'
import { getPayResultByOrderNo } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import navcon from '../components/navcon.vue'
import QRCode from 'qrcodejs2'
// import '../../project/static/js/qrcode.min.js'

export default {
  name: 'navcon',
  data() {
    return {
      loginState: false,
      registerUser: false,
      dialogFormVisible: false,
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      wxPlay: require('../assets/img/show.png'),
      user: {
        username: '超级管理员'
      },
      upPass: false,
      loginDialog: '',
      wxDialog: '',
      czDialog: '',
      bounty: 0,
      balance: 0,
      gridData: [{}],
      dialogTableVisible: false,
      wxPlayDialog: false,
      formInline: {},
      commissionUrl: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '50px',
      fromOption: {},
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      registerUser: false,
      userLogin: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
        code: '',
        randomStr: '',
        codeimg: ''
      },
      formInline: {},
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      }
    }
  },
  // 注册组件
  components: {
    registerInterface
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd();
    let user = localStorage.getItem('userdata');
    if (user != null) {
      this.user = JSON.parse(user);
      this.getSize();
      this.getBounty();
      this.commissionUrl = "https://cx.dataad.net/#/register?referenceId=" + this.user.id
    } else {
      this.loginState = true;
    }
    if(this._isMobile()){
      this.loginDialog='100%';
      this.wxDialog='100%';
      this.czDialog='100%';
    }else{
      this.loginDialog='35%';
      this.wxDialog='15%';
      this.czDialog='20%';
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    // 点击 el-submenu 时可以跳转
    handleSelectMenu(path) {
      this.$router.push({ path: path })
      this.$router.push(path)
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            localStorage.clear()
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    recharge() {
      this.dialogFormVisible = false;
      this.wxPlayDialog = true;
      this.content = '';
      // 支付金额
      let total_F = 0;
      // 1次3元，10次25元，30次50元
      if (this.fromOption.option == 1) {
        // total_F = 1;
        total_F = 3 * 100;
      }
      if (this.fromOption.option == 2) {
        // total_F = 2;
        total_F = 25 * 100;
      }
      if (this.fromOption.option == 3) {
        // total_F = 3;
        total_F = 50 * 100;
      }
      // 发送请求，获取支付地址
      const res = nativePay(total_F).then(res => {
        if (res.code == 200) {
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            // 获取到div元素
            let qrBox = document.getElementById('qrcode')
            const qrObj = new QRCode(qrBox, {
              errorCorrectionLevel: "H",//容错级别
              type: "image/png",//生成的二维码类型
              quality: 0.3,//二维码质量
              margin: 12,//二维码留白边距
              width: 200,//宽
              height: 180,//高
              text: res.data.wxPayUrl,//二维码内容
              color: {
                dark: "#333333",//前景色
                light: "#fff"//背景色
              }
            });
            this.loopOrderState(res.data.orderNo);
          })
        } else {
          this.$message.error('请先登录后再重试！')
        }
      });
      // 将支付地址转为二维码，显示（QRCode参数为（二维码展示的盒子节点元素，显示的内容））
      // 这是vue项目，我将QRCode.min.js文件下载并在index.html引入了，因此在此文件看不到引入  
    },
    loopOrderState(orderNo) {//轮询当前订单状态s
      this.T = setInterval(() => {
        if (this.wxPlayDialog) {
          getPayResultByOrderNo(orderNo).then((res) => {
            if (res.data == true) {//false是未支付  true已付款
              clearInterval(this.T)
              this.dialogTableVisible = false;
              this.wxPlayDialog = false;
              this.$message({
                type: 'success',
                message: '充值成功!'
              });
              setTimeout(() => {
                location.reload();
              }, 1000)
            }
          });
        } else {
          clearInterval(this.T)
        }
      }, 1000)
    },
    getSize() {
      getSizeByUserId().then(res => {
        if (res.code == 200) {
          this.balance = res.data
        } else {
          if (res.code == 400) {
            localStorage.clear()
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
          } else {
            this.$message.error('获取剩余次数失败！')
          }
        }
      })
    },
    getBounty() {
      getBountyByUserId().then(res => {
        if (res.code == 200) {
          this.bounty = res.data
        } else {

          this.$message.error('获取赏金失败！')
          this.$store.commit('logout', 'false')
          this.$router.push({ path: '/login' })
        }
      })
    },
    upPassword(params) {
      let formInline = this.formInline;

      if (formInline.oldPassword != null && formInline.oldPassword != '' && formInline.password != null && formInline.password != '') {
        updatePassword(formInline).then(res => {
          this.upPass = false;
          if (res.code == 200) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
          }
        })
      } else {
        this.$message.error('请输入旧密码与新密码！')
        return false
      }

    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          // 测试通道，不为空直接登录
          // setTimeout(() => {
          // this.logining = false
          // this.$store.commit('login', 'true')
          // this.$router.push({ path: '/goods/address' })
          // }, 1000)
          // 注释
          login(this.ruleForm).then(res => {
            console.warn(res);
            debugger;
            if (res.data.code == 200) {
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie('user', this.ruleForm.username, 7)
                //保存密码到cookie，有效期7天
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false
                // 缓存token
                localStorage.setItem('logintoken', res.data.data.token)
                // 缓存用户个人信息
                localStorage.setItem('userdata', JSON.stringify(res.data.data))
                this.$store.commit('login', 'true')
                this.$router.push({ path: '/goods/address' })
              }, 1000)
            } else {
              this.$message.error(res.data.message)
              this.logining = false
              return false
            }
          })
        } else {
          this.$message.error('请输入手机号与密码！')
          this.logining = false
          return false
        }
      })
    },
    userRegister(params) {
      let formInline = this.formInline;
      if (formInline.username != null && formInline.username != ''
        && formInline.password != null && formInline.password != '') {
        register(formInline).then(res => {
          this.registerUser = false;
          if (res.code == 200) {
            this.$message({
              message: '注册成功！',
              type: 'success'
            });
          }
        })
      } else {
        this.$message.error('请输入手机号与密码！')
        return false
      }

    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  float: right;
}

.logo {
  height: 70px;
  background-color: transparent;
  border: none;
}

.logoName {
  height: 60px;
  font-size: 25px;
  margin-left: 40px;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}

/deep/ .el-radio-button__inner {
  margin-top: 20px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.el-radio-button {
  width: 100%;
}

.container {
  text-align: center;
}

.login-container {
  /* border-radius: 10px; */
  width: 100%;
  /* padding: 30px 35px 15px 35px; */
  background: #fff;
  /* border: 1px solid #eaeaea; */
  text-align: left;
}

.dialog {
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  /* border: 1px solid #eaeaea;  */
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}

/deep/ .el-input__inner::-webkit-outer-spin-button,
/deep/ .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/ .el-input__inner[type='number'] {
  -moz-appearance: textfield;
}

.bg-purple-dark {
  display: flex;
  justify-content: space-between;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue